





























































































import mixins from 'vue-typed-mixins';
import { ReportNode, ReportContext } from '@/utils/ReportUtils';
import DocumentsUtils, {
  Document,
  DocumentAssociation,
} from '@/utils/DocumentsUtils';
import DocumentUpload from '@/components/documents/DocumentUpload.vue';
import { Question, SurveyParticipation } from '@/utils/SurveyUtils';
import cloneDeep from 'lodash.clonedeep';

export default mixins().extend({
  components: {
    DocumentUpload,
  },

  props: {
    node: {
      type: Object as () => ReportNode,
    },
    context: {
      type: Object as () => ReportContext,
    },
  },

  computed: {
    associations(): any {
      return this.context.questions
        ?.filter((question) => question.options?.documents?.visible)
        ?.map((question) => ({
          text: question.fullquestionnumber,
          value: {
            surveyparticipation: this.context.surveyParticipation,
            question: question,
          },
        }));
    },

    documents(): any {
      return {
        items: this.context.documents?.items,
        headers: [
          { text: this.$tc('model.document.name'), value: 'name' },
          {
            text: this.$tc('model.document.description'),
            value: 'description',
          },
          {
            text: this.$tc('model.document.associations', 2),
            value: 'associations.question.fullquestionnumber',
          },
          { text: this.$tc('model.document.uploaddate'), value: 'uploaddate' },
        ],
      };
    },
  },

  data(): {
    document?: Document;
  } {
    return {
      document: undefined,
    };
  },

  async mounted() {
    this.loadDocuments();
  },

  watch: {
    'context.documents.options.showAllDocuments'() {
      this.loadDocuments(true);
    },
  },

  methods: {
    async loadDocuments(forceLoad?: boolean) {
      try {
        if (!this.context.documents.items || forceLoad) {
          this.context.documents.items = undefined;
          let documents: Document[] = [];
          if (this.context.surveyParticipation) {
            documents = await DocumentsUtils.api.list({
              serviceproviderid: this.context.surveyParticipation
                .serviceprovider.id as number,
              surveyparticipationid: this.context.documents.options
                .showAllDocuments
                ? undefined
                : this.context.surveyParticipation?.id,
            });
          }
          if (!this.context.documents.items) {
            this.context.documents.items = Array.from(documents);
          }
        }
      } catch (error) {
        this.$alert.show('mounted', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },

    async upload(document: Document) {
      if (this.context.documents?.items) {
        this.context.documents.items.push(document);
        this.context.documents.items = Array.from(this.context.documents.items);
      }
    },

    async download(document: Document) {
      await DocumentsUtils.api.download([document]);
    },

    async bulkDownload() {
      if (this.context.documents?.items) {
        await DocumentsUtils.api.download(
          this.context.documents.items.filter(
            (document) =>
              document.associations && document.associations?.length > 0
          )
        );
      }
    },

    edit(document: Document) {
      this.document = cloneDeep(document);
      this.document.associations = this.document.associations
        ?.map(
          (association) =>
            this.associations?.find(
              (item: any) => item.value.question.id === association.question?.id
            )?.value
        )
        ?.filter((value) => !!value);
    },

    async saveEdit() {
      if (this.context.documents?.items && this.document) {
        try {
          (this.$refs.alert as any).hide('saveEdit');

          if (
            this.document.associations &&
            this.document.associations.length === 0
          ) {
            this.document.associations = null; // set to null to clear if empty
          }

          this.document = (
            await DocumentsUtils.api.update(
              [this.document],
              this.context.surveyParticipation as SurveyParticipation
            )
          )[0];
          const index = this.context.documents?.items?.findIndex(
            (document) => document.id === this.document?.id
          );
          if (index >= 0) {
            this.context.documents.items[index] = this.document;
          }
          this.document = undefined;
        } catch (error) {
          (this.$refs.alert as any).show('saveEdit', {
            type: 'error',
            messages: this.$handleAPIError(error),
          });
        }
      }
    },

    async remove(item: Document) {
      await this.$confirm(
        this.$i18n.t('validation.confirmation.delete', [item.name]).toString(),
        async () => {
          if (this.context.documents?.items) {
            try {
              this.$alert.hide('remove');
              if (item.id) {
                await DocumentsUtils.api.remove(item.id);
              }
              const index = this.context.documents.items.findIndex(
                (document) => document.id === item.id
              );
              if (index >= 0) {
                this.context.documents.items.splice(index, 1);
                this.context.documents.items = Array.from(
                  this.context.documents.items
                );
              }
            } catch (error) {
              this.$alert.show('remove', {
                type: 'error',
                messages: this.$handleAPIError(error),
              });
            }
          }
        }
      );
    },
  },
});
